// iOS/iPadOS ignores the download attribute on data: URLs, so callers should
// always hand this a Blob rather than building a data URL themselves.
export function downloadBlob(blob, filename) {
    const objectUrl = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = filename;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Safari cancels the in-flight download if the object URL is revoked in the
    // same task as the click, so it is released on a timer instead.
    setTimeout(() => URL.revokeObjectURL(objectUrl), 5000);
}
